import { LitElement, html, css } from 'lit'
import './card'
customElements.define('k-reviews-list', class extends LitElement{

    static styles = css`
        :host {
            display: block;
            position:relative;
        }

        k-review-card {
            font-size: 1.2em;
        }
    `

    constructor(){
        super()
        this.data = window.reviewData || []
    }

    render(){return html`
        <b-grid cols="1" cols-mobile="1" gap=2>
            ${this.data.map(d=>html`
                <k-review-card .data=${d}></k-review-card>
            `)}
        </b-grid>
    `}

})

export default customElements.get('k-rev')